const Manufacture = ({prm}) => {
  return (
    <div className="text-center">                       
        <div className="Products">
            <img src={prm.image} alt={prm.name}/> 
        </div>                            
    </div>
  )
}
export default Manufacture